import config from '../config'

const websiteURL = config.URL.website

const links = {
  privacyPolicy: {
    en: `${websiteURL}assets/files/privacy-policy-1.pdf?v=1.6`,
    fa: `${websiteURL}assets/files/fa/privacy-policy-1.pdf?v=1.6`,
    es: `${websiteURL}assets/files/es/privacy_policy_1.pdf`,
  },
  partnersAgreement: {
    en: `${websiteURL}assets/files/partners-agreement-1.pdf?v=1.2`,
    fa: `${websiteURL}assets/files/fa/partners-agreement-1.pdf?v=1.2`,
    es: `${websiteURL}assets/files/es/partners_agreement_1.pdf`,
  },
  riskDisclosure: {
    en: `${websiteURL}assets/files/risk-disclosure-1.pdf?v=1.5`,
    fa: `${websiteURL}assets/files/fa/risk-disclosure-1.pdf?v=1.5`,
    es: `${websiteURL}assets/files/es/risk_disclosure_1.pdf`,
  },
  contact: {
    en: `${websiteURL}contact`,
    fa: `${websiteURL}fa/contact`,
    es: `${websiteURL}es/contact`,
  },
  vpsTermsAndConditions: {
    en: `${websiteURL}assets/files/vps-terms-and-conditions-1.pdf?v=1.8`,
    fa: `${websiteURL}assets/files/fa/vps-terms-and-conditions-1.pdf?v=1.8`,
    es: `${websiteURL}assets/files/es/vps_terms_and_conditions-1.pdf`,
  },
  termsOfService: {
    en: `${websiteURL}assets/files/account-opening-agreement-1.pdf?v=2.6`,
    fa: `${websiteURL}assets/files/fa/account-opening-agreement-1.pdf?v=2.4`,
    es: `${websiteURL}assets/files/es/account-opening-agreement-1.pdf?v=1.1`,
  },
  acceptTheLpoa: {
    en: `${websiteURL}assets/files/lpoa.pdf`,
    fa: `${websiteURL}assets/files/fa/lpoa.pdf`,
    es: `${websiteURL}assets/files/es/lpoa.pdf`,
  },
  noDepositBonusURL: {
    en: `${websiteURL}assets/files/no-deposit-bonus-terms-and-conditions.pdf?v=1.6`,
  },
  competitionTCsURL: {
    en: `${websiteURL}assets/files/trading-competition-terms.pdf?v=1.0`,
    fa: `${websiteURL}assets/files/fa/trading-competition-terms.pdf?v=1.0`,
  },
  plexypowerBonusURL: {
    en: `${websiteURL}assets/files/plexypower-100-tradeable-bonus.pdf?v=1.2`,
  },
  companyLegalDoc: {
    en: `${websiteURL}company/legal-documents/`,
    fa: `${websiteURL}fa/company/legal-documents/`,
    es: `${websiteURL}es/company/legal-documents/`,
  },
  mt4WebTrader: {
    en: `https://www.plexytrade.com/platforms/metatrader-4-webtrader/`,
    fa: `https://www.plexytrade.com/fa/platforms/metatrader-4-webtrader/`,
    es: `https://www.plexytrade.com/es/platforms/metatrader-4-webtrader/`,
  },
  mt5WebTrader: {
    en: `https://www.plexytrade.com/platforms/metatrader-5-webtrader/`,
    fa: `https://www.plexytrade.com/fa/platforms/metatrader-5-webtrader/`,
    es: `https://www.plexytrade.com/es/platforms/metatrader-5-webtrader/`,
  },
  promotionWelcomeBonus: {
    en: `${websiteURL}promotions/welcome-bonus`,
    fa: `${websiteURL}fa/promotions/welcome-bonus`,
    es: `${websiteURL}es/promotions/welcome-bonus`,
  },
  vpsToolsHosting: {
    en: `${websiteURL}tools/vps-hosting`,
    fa: `${websiteURL}fa/tools/vps-hosting`,
    es: `${websiteURL}es/tools/vps-hosting`,
  },
  pamm: {
    en: `${websiteURL}platforms/pamm/`,
    fa: `${websiteURL}fa/platforms/pamm/`,
    es: `${websiteURL}es/platforms/pamm/`,
  },
  copyTrading: {
    en: `${websiteURL}en/platforms/copy-trading/`,
    fa: `${websiteURL}fa/platforms/copy-trading/`,
    es: `${websiteURL}es/platforms/copy-trading/`,
  },
  bonusTermsConditions: {
    en: `${websiteURL}assets/files/bonus-terms-and-conditions-1.pdf?v=2.2`,
    fa: `${websiteURL}assets/files/fa/bonus-terms-and-conditions-1.pdf?v=2.1"`,
    es: `${websiteURL}assets/files/es/bonus_terms_and_conditions-1.pdf`,
  },
  twitterLinks: {
    en: `https://twitter.com/plexytrade`,
    fa: `https://linktr.ee/plexytrade`,
    es: `https://twitter.com/plexytrade`,
  },
  instagramLinks: {
    en: `https://www.instagram.com/plexytrade.official`,
    fa: `https://linktr.ee/plexytrade`,
    es: `https://www.instagram.com/plexytrade.official`,
  },
  facebookLinks: {
    en: `https://www.facebook.com/PlexyTrade`,
    fa: `https://linktr.ee/plexytrade`,
    es: `https://www.facebook.com/PlexyTrade`,
  },
  tradingCentralURL:{
    en: `${websiteURL}trading-central`,
    fa: `${websiteURL}fa/trading-central`,
    es: `${websiteURL}es/trading-central`,
  },
  cashbackTermsConditions: {
    en: `${websiteURL}assets/files/cashback-rebates-program–terms-and-conditions.pdf`,
    fa: `${websiteURL}assets/files/fa/cashback-rebates-program–terms-and-conditions.pdf`,
    es: `${websiteURL}assets/files/es/cashback-rebates-program–terms-and-conditions.pdf`,
  },
  cashbackFAQsUrl: {
    en: `${websiteURL}promotions/cashback/#faqs`,
    fa: `${websiteURL}fa/promotions/cashback/#faqs`,
    es: `${websiteURL}es/promotions/cashback/#faqs`,
  },

  // Method to get the correct link based on language, with fallback to English
  getLink(key, language = 'en') {
    const link = this[key]

    // Check if link is an object with language-specific URLs
    if (typeof link === 'object') {
      // Return the language-specific link if available, else fallback to English
      return link[language] || link.en || ''
    }

    // If the link is a direct string, return it directly
    return link || ''
  },
}

export default links
